import "./Menu.css";

import * as React from "react";
import { TView } from "../App";

interface IMenuProps {
    changeHandler: (view: TView) => void;
    currentView?: TView;
}

interface IMenu {
    view: TView;
    label: string;
}

export default class Menu extends React.Component<IMenuProps, {}> {

    public constructor(props: IMenuProps) {
        super(props);
    }

    public render() {

        const nonBreakingSpace = "\u00A0";

        const links: Array<IMenu> = [
            { view: "news", label: "Aktuelles" },
            { view: "music", label: "Musik" },
            { view: "living-room", label: "Wohnzimmer" },
            { view: "guest-book", label: "Gästebuch" },
            { view: "contact", label: "Kontakt" },
            { view: "about-us", label: `Über${nonBreakingSpace}uns` }
        ];

        const { currentView } = this.props;

        return (
            <div className="Menu">
                <div className="Menu__links">
                    <div
                        className="homeLink"
                        onClick={() => this.handleClickOnLink("index")}
                    >
                        <span>HERZ</span>WEG
                    </div>
                    {links.map((link) => {
                        const modifier = currentView === link.view ? "Menu__link--active" : "";
                        return [
                            (
                                <a
                                    onClick={() => this.handleClickOnLink(link.view)}
                                    className={"Menu__link " + modifier}
                                    key={link.view}
                                >
                                    {link.label}
                                </a>
                            ),
                            <br key={`${link.view}_br`} className="Menu__mobileBreak"/>
                        ];
                    })}
                </div>
            </div>
        );
    }

    private handleClickOnLink = (view: TView) => {
        this.props.changeHandler(view);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Menu.tsx